import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Theme } from 'widget/styles/themes';

type Props = {
  'data-test'?: string;
  hidden?: boolean;
  index?: number;
  theme?: Theme;
};

const rise = keyframes({
  '100%': { transform: 'translateY(0)' },
});

const Bar = styled('rect')<Props>(({ hidden = false, index, theme }) => ({
  '&:nth-of-type(even)': {
    fill: hidden ? 'transparent' : theme.filledProgressBars, // IE hack, does not animate but at least shows / hides the filled bars
    transform: hidden ? 'translateY(100%)' : 'translateY(0)',
    transition: 'all 300ms ease',
  },

  '&:nth-of-type(odd)': {
    animationDelay: `${index! * 5 + 100}ms`,
    animationDuration: '500ms',
    animationFillMode: 'forwards',
    animationName: rise,
    animationTimingFunction: 'ease',
    fill: theme.progressBars,
    transform: 'translateY(100%)',
  },
}));

export default Bar;
